<template>
	<div>
        <div class="table-loading" v-if="isLoading">
            <Loading :isLoading="isLoading"></Loading>
        </div>
		<div class="overall" v-else>
            <div class="tickets-list-route ">
                <ul >
                    <li @click="routetokPage('/tickets')">门票预订 ></li>
                    <li @click="routetokPage('/ticketList?Str='+Str)">门票列表 > </li>
                    <li class="active">{{details.ScenicName}}</li>
                </ul>
                <div class="tickets-list-route-back"  @click="routetokPage('/ticketList?Str='+Str)">← 返回</div>
            </div>
			<div class="product">
				<div class="product-name">
					<div class="left">
						<h4>{{details.ScenicName}}</h4>
					</div>
					<div class="right" >
						<div class="price-a" v-if="details.LowestPrice">
							<p>￥<span> {{details.LowestPrice}} </span>起</p>
						</div>
						<div class="btn" @click="toBookTable">
							立即抢购
						</div>
					</div>
				</div>
				<div class="ticket-main-content">
                    <PhotosBox :pics="photos" ></PhotosBox>
					<div class="tmc-content">
						<div class="tmc-time">
        					<div>
                                <label>景点地址 ：</label>
                                <p> {{details.ScenicAddr}}</p>
                            </div>
        					<div>
                                <label>营业时间 ：</label>
                                <div>
                                    <p v-for="item in ScenicOpenTimes" v-if="ScenicOpenTimes">{{item.Info}} </p>
                                </div>
                    
                            </div>
        					<div>
                                <label>景区级别 ：</label>
                                <p v-if="details.ScenicLevel"> {{details.ScenicLevelName}}级景区</p>
                            </div>
    					</div>
						<div class="tm-map">
                            <MapView :mapContent="mapContent"  :mapCenter="mapCenter" ></MapView>
						</div>
					</div>
				</div>				
			</div>
            <div class="ScenicInfos" v-if="details.ScenicInfos&&details.ScenicInfos.PostInfo&&details.ScenicInfos.PostInfo.length>=0">
                <p v-for="(item,i) in details.ScenicInfos.PostInfo" :key="i">{{item.Info}}</p>
            </div>
			<div class="attractions-form" ref="ticketTable">

    			<table class="form-table">
            		<thead>
                		<tr>
                    		<th colspan="2">产品名称</th>
                    		<th width="10%">预订须知</th>
                    		<th width="10%">改退规则</th>
                    		<!-- <th width="10%">门市价</th> -->
                    		<th width="10%">订房易价</th>
                    		<th width="15%">预订</th>
                		</tr>
            		</thead>
                    <tbody v-for="item in TicketsList">
                        <tr v-for="(ticket,index) in item.TicketInfos">
                            <td width="10%" :rowspan="item.TicketInfos.length" class="adult" v-if="index==0">{{ticketType[item.TicketTypeId]}} </td>
                            <td width="35%">{{ticket.TicketName}}</td>
                            <td width="10%"><div class="reservation" @click="openBooknotice(ticket)">预订须知</div></td>
                            <td width="10%"><div class="rules"> {{ticket.IsRegression?'条件退':'不可退'}}  </div></td>
                            <!-- <td width="10%"><span>￥150(无数据)</span></td> -->
                            <td width="10%"><span>￥<span class="price">{{ticket.LowestPrice}}</span>起</span></td>
                            <td width="15%"><div class="reservation-btn" @click="book(ticket)">预订</div><div>立即确认</div></td>
                        </tr>  
                    </tbody>
            
            	
        		</table>

    		</div>
    		<div class="attractions-booking">
        		<div :class="isPageActive?'booking active':'booking'" @click="isPageActive=true">预订须知</div>
        		<div :class="!isPageActive?'booking active':'booking'" @click="isPageActive=false">景点介绍</div>
    		</div>
    		<div class="attractions-content" v-if="isPageActive">
            	<!-- <div class="content-title">预订须知</div> -->
           	 	<div class="content-body">
                	<p>开放时间</p>
                    <p v-for="item in ScenicOpenTimes" v-if="ScenicOpenTimes">{{item.Info}} </p>
            	</div>
            	<div class="content-body">
                	<p>免票政策</p>
                    <p>{{details.FreePolicy}}</p>
            	</div>
                <div class="content-body">
                    <p>优惠人群</p>
                    <p>{{details.OfferCrowd}}</p>
                </div>
            	<div class="content-body">
                	<p>开具发票</p>
                	<p>如需开具发票，可直接通过公众号联系龙猫游客服。</p>
            	</div>
                <div class="content-body">
                    <p>入园须知</p>
                    <p>{{details.Explanation}}</p>
                </div>
            	<div class="content-body">
                	<p>温馨提示</p>
                	<p>1.  为了您人身、财产的安全，请您避免在公开场合暴露贵重物品及大量现金。上街时需时刻看管好首饰、相机等随身物品。</p>
                    <p>2.  游泳、漂流、潜水、滑雪、滑冰、戏雪、热气球、跳伞、浮潜、摩托艇、滑翔伞、动力伞、攀岩等活动项目，均存在危险。参与前请根据自身条件，并充分参考当地相关部门及其它专业机构的相关公告和建议后量力而行。请您在预订前阅读驴妈妈为您整理各项高风险活动的 <label class="book-notice" @click="isRullShow=!isRullShow">《安全须知》</label></p>
            	</div>
                <div class="content-body">
                    <Rull v-show="isRullShow"></Rull>
                </div>
        	</div>
            <div class="attractions-content"  v-if="!isPageActive">
                <!-- <div class="content-title">景点介绍</div> -->
                <div class="content-body">
                    
                    <p>{{details.Description}}</p>
                </div>
                <div class="content-body">
                    <p>免票政策</p>
                    <p>{{details.FreePolicy}}</p>
                </div>
                <div v-for="item in details.ScenicInfos.PlayAttraction" v-if="details.ScenicInfos.PlayAttraction" class="content-body">
                    <p>{{item.Name}}</p>
                    <p>{{item.Info}}</p>
                    <div class="attractions-pics">
                        <img :src="img.Url | replaceImgSrc(100)"  v-for="img in item.Images"/>
                    </div>
                </div>
                <div  v-if="!details.ScenicInfos.PlayAttraction&&!details.Description">
                    <p>  暂无数据</p>
                </div>
            </div>
		</div>
        <BookNotice :info="ticket" v-if="isBookNoticeShow" @close="isBookNoticeShow=false"></BookNotice>
    </div>
</template>

<script>
    import Loading from './../../common/cmpnt/Loading/Loading.vue'//缓冲
    import PhotosBox from './photosBox/photosBox.vue'//图片查看器
    import MapView from './../../common/cmpnt/map/Map.vue'//地图
    import BookNotice from './bookNotice/bookNotice.vue'//预订需知
    import Rull from './bookNotice/rull.vue'//安全需知
    const ticketType=require('./type.js');//门票类型
    export default{
        components: {
            Loading,
            PhotosBox,
            MapView,
            BookNotice,
            Rull
         
        },
        data(){
            return{
                Str:this.$route.query.Str||'',
                id:this.$route.query.id||'',
                details:'',
                TicketsList:'',
                ScenicOpenTimes:'',
                ticketType:ticketType.ticketType,
                isLoading:false,
                isPageActive:true,
                isBookNoticeShow:false,
                isRullShow:false,
                photos:[],
                mapContent:'',
                mapCenter:{},
                ticket:''
            }
        },
        methods:{
            toBookTable(){
                console.log(this.$refs);
                var height = this.$refs['ticketTable'].offsetTop;
                window.scrollTo(0,height);

            },
            //查看预订需知
            openBooknotice(item){
                console.log(item)
                this.isBookNoticeShow=true;
                this.ticket=item;
            },
            //获取门票信息
            initData(){
                var that=this;
                that.isLoading=true;
                that.getRequest({
                    url: that.Api.getticketDetails+'?id='+this.id,
                }).then(res => {
                    that.isLoading=false;
                    if (res&&res.IsSuccess) {
                        that.details=res.Result;
                        that.ScenicOpenTimes=res.Result.ScenicInfos.ScenicOpenTimes||'无';
                        that.TicketsList=res.Result.TicketsList ;
                        that.photos=res.Result.Pics ;
                        document.title=res.Result.ScenicName+'门票预订---订房易';
                        var center={
                            lat:that.details.Latitude,
                            lng:that.details.Longitude,
                            name:that.details.ScenicName,
                        }
                        that.mapContent=res.Result.ScenicName;
                        that.mapCenter=center;

                    } else {
                        that.details='';
                    }
                });
            },
            //填写订单
            book(tk){
                tk.ScenicName=this.details.ScenicName;
                tk.Explanation=this.details.Explanation;
                this.dao.set('ticketBookInfo',tk);
                this.$router.push('/ticketBook');
            }
        },
        mounted(){
            
            this.initData();
        }
    }
</script>




// WEBPACK FOOTER //
// src/components/ticket/Details.vue